import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import { IdSchemaType } from "../../Configurator/Types/ConfiguratorTypes";
import MappingFacade from "./Facade/MappingFacade";

export default class IdMapping {
  private facade: MappingFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new MappingFacade(config);
  }

  public getMappedFootballCountryIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    return await this.facade.getMappedFootballCountryIds(
      ids,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballCompetitionIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    return await this.facade.getMappedFootballCompetitionIds(
      ids,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballTeamIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    return await this.facade.getMappedFootballTeamIds(
      ids,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballPlayerIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    return await this.facade.getMappedFootballPlayerIds(
      ids,
      inputProvider,
      outputProvider
    );
  };

  public getMappedFootballMatchIds = async (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    return await this.facade.getFootballMappedMatchIds(
      ids,
      inputProvider,
      outputProvider
    );
  };
}
